type SubItemsType = ISubItemGroupDisplay | ISubItemGroup;

export const isSubItemGroupRequired = (sig: SubItemsType | IMenuItem): boolean => {
  return (sig as SubItemsType)?.min > 0;
};
